import React from 'react';
import { useTranslation } from 'react-i18next';

// ── COULEURS (via CSS variables) ─────────────────────────────────────────
export const C = {
  bg:      'var(--bg)',      surface: 'var(--bg)',    surface2: 'var(--bg-muted)',
  border:  'var(--border)',  text:    'var(--text)',   text2:    'var(--text2)',
  text3:   'var(--text3)',   accent:  'var(--blue)',   danger:   'var(--red)',
  warn:    'var(--amber)',   ok:      'var(--green)',  gold:     'var(--amber)',
  g1:'var(--green)', g2:'var(--blue)', g3:'var(--orange)', g4:'var(--red)',
  v1:'var(--blue)',  v2:'var(--purple)', v3:'var(--orange)', v4:'var(--red)',
};

// ── ICÔNES LUCIDE (inline SVG) ────────────────────────────────────────────
const svgProps = { viewBox:'0 0 24 24', fill:'none', stroke:'currentColor', strokeWidth:1.75, strokeLinecap:'round', strokeLinejoin:'round' };
export const Icon = {
  Sun:     () => <svg {...svgProps} width="15" height="15"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
  Moon:    () => <svg {...svgProps} width="15" height="15"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  Plus:    () => <svg {...svgProps} width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Edit:    () => <svg {...svgProps} width="13" height="13"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash:   () => <svg {...svgProps} width="13" height="13"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  X:       () => <svg {...svgProps} width="15" height="15"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Share:   () => <svg {...svgProps} width="14" height="14"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Print:   () => <svg {...svgProps} width="14" height="14"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>,
  Info:    () => <svg {...svgProps} width="14" height="14"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  Chevron: () => <svg {...svgProps} width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>,
};

// ── THEME TOGGLE ─────────────────────────────────────────────────────────
export function ThemeToggle({ theme, onToggle }) {
  const { t } = useTranslation();
  const isDark = theme === 'dark';
  const [hov, setHov] = React.useState(false);
  return (
    <button onClick={onToggle} title={isDark ? t('theme.dark') : t('theme.light')}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{ ...S.iconBtn, background: hov ? 'var(--bg-muted)' : 'transparent', borderColor: hov ? 'var(--border)' : 'transparent' }}>
      {isDark ? <Icon.Sun /> : <Icon.Moon />}
    </button>
  );
}

// ── BADGE ─────────────────────────────────────────────────────────────────
const BADGE_VARIANTS = {
  green:  { bg:'var(--green-bg)',  color:'var(--green)',  border:'var(--green-border)' },
  blue:   { bg:'var(--blue-bg)',   color:'var(--blue)',   border:'var(--blue-border)' },
  orange: { bg:'var(--orange-bg)', color:'var(--orange)', border:'var(--orange-border)' },
  red:    { bg:'var(--red-bg)',    color:'var(--red)',    border:'var(--red-border)' },
  amber:  { bg:'var(--amber-bg)',  color:'var(--amber)',  border:'var(--amber-border)' },
  purple: { bg:'var(--purple-bg)', color:'var(--purple)', border:'var(--purple-border)' },
  default:{ bg:'var(--bg-muted)',  color:'var(--text2)',  border:'var(--border)' },
};

export function graviteVariant(g) { return ['','green','blue','orange','red'][g] || 'default'; }
export function vraisVariant(v)   { return ['','blue','purple','orange','red'][v] || 'default'; }
export function scoreVariant(s) {
  if (s >= 9) return 'red';
  if (s >= 6) return 'orange';
  if (s >= 3) return 'blue';
  return 'green';
}
export function pertinenceVariant(p) {
  const map = { 'Faible':'green','Moyenne':'amber','Élevée':'red','Low':'green','Medium':'amber','High':'red','Hoch':'red','Mittel':'amber','Gering':'green','Alta':'red','Media':'amber','Bassa':'green' };
  return map[p] || 'default';
}
export function statutVariant(s) {
  const map = { 'Réalisé':'green','Done':'green','Erledigt':'green','Completato':'green','En cours':'blue','In progress':'blue','In Bearbeitung':'blue','In corso':'blue','À planifier':'default','To plan':'default','Reporté':'amber','Deferred':'amber' };
  return map[s] || 'default';
}

export function Badge({ color, variant, children, bold }) {
  const v = BADGE_VARIANTS[variant] || (color ? null : BADGE_VARIANTS.default);
  const style = v
    ? { background: v.bg, color: v.color, border: `1px solid ${v.border}` }
    : { background: color + '18', color, border: `1px solid ${color}40` };
  return (
    <span style={{ display:'inline-flex', alignItems:'center', padding:'2px 8px', borderRadius:4, fontSize:11.5, fontWeight: bold||variant==='red'||variant==='orange' ? 600 : 500, whiteSpace:'nowrap', letterSpacing:0.1, ...style }}>
      {children}
    </span>
  );
}

export function Tag({ children }) {
  return <span style={{ display:'inline-flex', padding:'2px 7px', background:'var(--bg-muted)', border:'1px solid var(--border)', borderRadius:4, fontSize:11, color:'var(--text3)', margin:'1px 2px' }}>{children}</span>;
}

// ── CARD ──────────────────────────────────────────────────────────────────
export function Card({ title, subtitle, action, children, style: s }) {
  return (
    <div style={{ background:'var(--bg-subtle)', border:'1px solid var(--border)', borderRadius:8, overflow:'hidden', marginBottom:16, ...s }}>
      {(title || action) && (
        <div style={{ padding:'14px 18px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
          <div>
            {title    && <div style={{ fontSize:13.5, fontWeight:700, color:'var(--text)', letterSpacing:-0.3, fontFamily:'var(--font-display)' }}>{title}</div>}
            {subtitle && <div style={{ fontSize:11.5, color:'var(--text3)', marginTop:2 }}>{subtitle}</div>}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

// ── HELP BOX ──────────────────────────────────────────────────────────────
export function HelpBox({ title, children }) {
  return (
    <div style={{ display:'flex', gap:10, alignItems:'flex-start', background:'var(--blue-bg)', border:'1px solid var(--blue-border)', borderRadius:7, padding:'11px 14px', fontSize:12.5, color:'var(--text2)', marginBottom:16 }}>
      <span style={{ color:'var(--blue)', marginTop:1, flexShrink:0 }}><Icon.Info /></span>
      <span><strong style={{ color:'var(--text)', fontWeight:600 }}>{title} </strong>{children}</span>
    </div>
  );
}

// ── EMPTY STATE ───────────────────────────────────────────────────────────
export function Empty({ icon = '—', text = 'Aucune donnée', sub }) {
  return (
    <div style={{ textAlign:'center', padding:'52px 20px', color:'var(--text3)' }}>
      <div style={{ fontSize:24, marginBottom:12, opacity:.25 }}>{icon}</div>
      <div style={{ fontSize:14, fontWeight:700, color:'var(--text2)', fontFamily:'var(--font-display)', letterSpacing:-0.2 }}>{text}</div>
      {sub && <div style={{ fontSize:12, marginTop:6, color:'var(--text3)', maxWidth:320, margin:'8px auto 0' }}>{sub}</div>}
    </div>
  );
}

// ── RISK ITEM ─────────────────────────────────────────────────────────────
export function RiskItem({ children }) {
  return <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12, padding:'11px 18px', borderBottom:'1px solid var(--border)' }}>{children}</div>;
}

// ── BUTTONS ───────────────────────────────────────────────────────────────
const btnBase = {
  primary:   { background:'var(--blue)',     color:'white',         border:'1px solid var(--blue)' },
  secondary: { background:'transparent',    color:'var(--text2)',  border:'1px solid var(--border)' },
  danger:    { background:'var(--red-bg)',  color:'var(--red)',    border:'1px solid var(--red-border)' },
  gold:      { background:'var(--amber-bg)',color:'var(--amber)',  border:'1px solid var(--amber-border)' },
};
const btnHov = {
  primary:   { background:'#1d4ed8', borderColor:'#1d4ed8' },
  secondary: { background:'var(--bg-muted)', borderColor:'var(--border-med)' },
  danger:    { background:'rgba(220,38,38,.12)', borderColor:'rgba(220,38,38,.4)' },
  gold:      { background:'rgba(217,119,6,.18)',  borderColor:'rgba(217,119,6,.4)' },
};

export function Btn({ children, onClick, variant='primary', disabled, type='button', style: s }) {
  const [hov, setHov] = React.useState(false);
  const base = btnBase[variant] || btnBase.primary;
  const hoverStyle = !disabled && hov ? (btnHov[variant] || {}) : {};
  return (
    <button type={type} onClick={onClick} disabled={disabled}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{ ...base, ...hoverStyle, padding:'7px 14px', borderRadius:6, fontSize:13, fontWeight:500, cursor:disabled?'not-allowed':'pointer', opacity:disabled?.55:1, display:'inline-flex', alignItems:'center', gap:6, transition:'all .12s', letterSpacing:-0.1, ...s }}>
      {children}
    </button>
  );
}

export function IconBtn({ onClick, danger, title, children }) {
  const [hov, setHov] = React.useState(false);
  return (
    <button onClick={onClick} title={title}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{ width:28, height:28, borderRadius:5, border:`1px solid ${hov?(danger?'var(--red-border)':'var(--border)'):'transparent'}`, background:hov?(danger?'var(--red-bg)':'var(--bg-muted)'):'transparent', color:hov?(danger?'var(--red)':'var(--text2)'):(danger?'var(--red)':'var(--text3)'), cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .12s' }}>
      {children}
    </button>
  );
}

// ── TABLE ─────────────────────────────────────────────────────────────────
export function DataTable({ cols, children, empty }) {
  const rows = React.Children.toArray(children);
  return (
    <div style={{ overflowX:'auto' }}>
      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
        <thead>
          <tr>{cols.map(c => (
            <th key={c} style={{ textAlign:'left', padding:'9px 16px', fontSize:10.5, fontWeight:600, color:'var(--text3)', borderBottom:'1px solid var(--border)', background:'var(--bg-muted)', whiteSpace:'nowrap', textTransform:'uppercase', letterSpacing:0.8 }}>{c}</th>
          ))}</tr>
        </thead>
        <tbody>
          {rows.length ? children : <tr><td colSpan={cols.length}>{empty || <Empty />}</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export function Td({ children, bold, small, right, mono }) {
  return <td style={{ padding:'11px 16px', color:bold?'var(--text)':'var(--text2)', fontWeight:bold?500:400, fontSize:small?12:13, fontFamily:mono?'var(--font-mono)':undefined, verticalAlign:'top', borderBottom:'1px solid var(--border)', textAlign:right?'right':'left' }}>{children}</td>;
}

export function TdActions({ onEdit, onDel }) {
  return (
    <td style={{ padding:'8px 16px', borderBottom:'1px solid var(--border)', textAlign:'right' }}>
      <div style={{ display:'flex', gap:4, justifyContent:'flex-end' }}>
        <IconBtn onClick={onEdit}><Icon.Edit /></IconBtn>
        <IconBtn onClick={onDel} danger><Icon.Trash /></IconBtn>
      </div>
    </td>
  );
}

// ── MODAL ─────────────────────────────────────────────────────────────────
export function Modal({ title, onClose, children, wide }) {
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.52)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(6px)', padding:20, animation:'fadeIn 0.15s ease' }}>
      <div style={{ background:'var(--bg-subtle)', border:'1px solid var(--border-med)', borderRadius:10, width:'90%', maxWidth:wide?720:540, maxHeight:'88vh', overflowY:'auto', boxShadow:'0 24px 64px rgba(0,0,0,.22)', animation:'fadeUp 0.18s ease' }}>
        <div style={{ padding:'18px 20px 14px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'var(--text)', letterSpacing:-0.3, fontFamily:'var(--font-display)' }}>{title}</div>
          <IconBtn onClick={onClose}><Icon.X /></IconBtn>
        </div>
        <div style={{ padding:'20px' }}>{children}</div>
      </div>
    </div>
  );
}

export function ModalFooter({ onCancel, onSave, saveLabel='Enregistrer' }) {
  return (
    <div style={{ display:'flex', justifyContent:'flex-end', gap:8, paddingTop:16, borderTop:'1px solid var(--border)', marginTop:16 }}>
      <Btn variant="secondary" onClick={onCancel}>Annuler</Btn>
      <Btn onClick={onSave}>{saveLabel}</Btn>
    </div>
  );
}

// ── FORM ──────────────────────────────────────────────────────────────────
export function FormGrid({ children }) {
  return <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>{children}</div>;
}
export function FG({ children, full, style: s }) {
  return <div style={{ display:'flex', flexDirection:'column', gap:5, ...(full?{gridColumn:'1/-1'}:{}), marginBottom:12, ...s }}>{children}</div>;
}
export function Label({ children }) {
  return <label style={{ fontSize:11, fontWeight:600, color:'var(--text3)', textTransform:'uppercase', letterSpacing:0.8 }}>{children}</label>;
}

const inputStyle = {
  background: 'var(--bg-muted)',
  border: '1px solid var(--border)',
  color: 'var(--text)',
  padding: '8px 12px',
  borderRadius: 6,
  fontSize: 13,
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
  transition: 'border-color .12s, box-shadow .12s',
};

export function Input({ style: s, ...props }) { return <input style={{ ...inputStyle, ...s }} {...props} />; }
export function Textarea({ rows=4, style: s, ...props }) { return <textarea style={{ ...inputStyle, resize:'vertical', minHeight:68, ...s }} rows={rows} {...props} />; }
export function Select({ children, style: s, ...props }) { return <select style={{ ...inputStyle, cursor:'pointer', ...s }} {...props}>{children}</select>; }

export function GraviteSelect({ value, onChange, t }) {
  const labels = t ? [t('gravite.label1'),t('gravite.label2'),t('gravite.label3'),t('gravite.label4')] : ['G1 — Mineure','G2 — Significative','G3 — Grave','G4 — Critique'];
  return <Select value={value} onChange={onChange}>{[1,2,3,4].map((v,i)=><option key={v} value={v}>{labels[i]}</option>)}</Select>;
}
export function VraisSelect({ value, onChange, t }) {
  const labels = t ? [t('vraisemblance.label1'),t('vraisemblance.label2'),t('vraisemblance.label3'),t('vraisemblance.label4')] : ['V1 — Peu vraisemblable','V2 — Vraisemblable','V3 — Très vraisemblable','V4 — Quasi certain'];
  return <Select value={value} onChange={onChange}>{[1,2,3,4].map((v,i)=><option key={v} value={v}>{labels[i]}</option>)}</Select>;
}

// ── SHARED STYLES ─────────────────────────────────────────────────────────
const S = {
  iconBtn: { width:32, height:32, borderRadius:6, border:'1px solid transparent', background:'transparent', color:'var(--text2)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .12s' },
};
